// extracted by mini-css-extract-plugin
export default {"language":"Language_language__Om1qD","test":"Language_test__EvF11"};